import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

export default function useGtmVariables() {
  const booking = useSelector((state) => state.booking);
  const event = useSelector((state) => state.event);
  const summary = useSelector((state) => state.summary, shallowEqual);
  const billboard = useSelector((state) => state.billboard, shallowEqual);

  useEffect(() => {
    if (window && event) {
      window.boletia = {
        id: event.event.id,
        season_id: billboard.id,
        name: event.event.name,
        category: event.event.event_type,
        currency: event.preferences.currency,
        order:
          booking && booking.order
            ? {
                number: booking.order,
                total: summary && summary.total_to_pay,
                tickets_count: booking.orderInfo?.tickets?.length,
              }
            : {
                number: '',
                total: 0,
                tickets_count: 0,
              },
      };
    }
  }, [event, booking, summary]);
  return null;
}
